// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"0122d9bf","570":"bd67670c","973":"ca558fcd"}[chunkId] + ".chunk.js";
};